import { getUser, wrappedGet, wrappedPost } from "../general/utils";
import { showToast } from "@sourcewhale/core";
import confetti from "canvas-confetti";

// Removed EUR, GBP, USD
const CURRENCY_CODES = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BOV",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "CNY",
  "COP",
  "COU",
  "CRC",
  "CUC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "FJD",
  "FKP",
  "GEL",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MXV",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLE",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SVC",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USN",
  "UYI",
  "UYU",
  "UZS",
  "VED",
  "VEF",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XDR",
  "XOF",
  "XPF",
  "XSU",
  "XUA",
  "YER",
  "ZAR",
  "ZMW",
  "ZWL",
];

/** @param {string} currency */
const winModalHtml = (currency) => {
  const eurSelected = currency.toLowerCase() === "eur" ? "selected" : "";
  const usdSelected = currency.toLowerCase() === "usd" ? "selected" : "";
  const gbpSelected =
    currency.toLowerCase() === "gbp" || !(eurSelected || usdSelected)
      ? "selected"
      : "";

  return /* html */ `
<!-- WIN MODAL -->
<div class="modal fade" role="dialog" tabindex="-1" id="winModal">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fa-regular fa-xmark fa-sm"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div id="winContents">
          <div id="winForm">
            <h2 class="win-title">Win with SourceWhale!</h2>
            <p class="win-description">Had a win using SourceWhale? Log it here - whether it be a successful placement or new business!</p>
            <p class="win-description">Wins shared here are confidential data. We will not share any of the information provided outside of your business without consent.</p>
            <div class="input-group my-3">
              <div class="input-group-prepend">
                <span class="input-group-text justify-content-center">Type of Win</span>
              </div>
              <select id="placementType">
                <option selected value="placement">Placed a Candidate</option>
                <option value="job">Won a Job</option>
              </select>
            </div>

            <div class="input-group my-3" data-toggle="tooltip" data-placement="right" title="Search for the contact associated with your win">
              <div class="input-group-prepend">
                <span class="input-group-text justify-content-center" id="winContactLabelText"></span>
              </div>
              <input class="form-control" id="winContact" type="input" autocomplete="off"/>
            </div>

            <div class="input-group my-3">
              <div class="input-group-prepend">
                <span class="input-group-text justify-content-center">Currency</span>
              </div>
              <select id="placementCurrency">
                <optgroup label="common">
                  <option value="gbp" ${gbpSelected}>GBP</option>
                  <option value="usd" ${usdSelected}>USD</option>
                  <option value="eur" ${eurSelected}>EUR</option>
                </optgroup>
                <optgroup label="other">
                  ${CURRENCY_CODES.map(
                    (code) =>
                      `<option value = "${code.toLowerCase()}" > ${code}</option >`,
                  ).join("")}
                </optgroup>
              </select>
            </div>

            <div class="input-group my-3">
              <div class="input-group-prepend">
                <span class="input-group-text justify-content-center">Estimated Revenue</span>
              </div>
              <input class="form-control" id="placementValue" type="number" autocomplete="off"/>
            </div>

            <div class="flex">
              <h6 class=my-3>Tell us more</h6>
              <textarea
                class="form-control p-3"
                id="placementNotes"
                placeholder="We'd love to know more about your win. Feel free to share any interesting stories or details!"
                maxlength="4500"
                rows="5"
                style="font-size: 90%"
              ></textarea>
            </div>
          </div>
          <div id="placementImage"><img src="/assets/img/wins/win-trophy.svg"></div>
        </div>
      </div>
      <div class="modal-footer my-2">
        <button class="btn btn-light" id="addWinBtn" type="button">Add Win</button>
      </div>
    </div>
  </div>
</div>
`;
};

const throwConfetti = (count = 0) => {
  setTimeout(
    () => {
      const x = 0.25 + 0.5 * Math.random();
      const y = 0.25 + 0.5 * Math.random();

      confetti({
        particleCount: 75,
        startVelocity: 15,
        spread: 360,
        origin: { x, y },
        decay: 0.9,
        gravity: 0.3,
        zIndex: 1051,
      });

      count += 1;
      if (count < 10) {
        throwConfetti(count);
      }
    },
    200 + Math.random() * 500,
  );
};

const initModal = () => {
  $("#addWinBtn").on("click", () => {
    const win = {
      candidateId: $("#winContact").attr("data-candidate-id"),
      placementType: $("#placementType").val(),
      placementCurrency: $("#placementCurrency").val(),
      placementValue: $("#placementValue").val(),
      placementNotes: $("#placementNotes").val(),
    };

    wrappedPost({
      url: "/api/wins/create",
      data: JSON.stringify(win),
      spinner: "#addWinBtn",
      enrichToast: (text) => {
        if (text.includes("fields"))
          return {
            title: "Missing Fields",
            type: "warning",
          };
        if (text.includes("already")) {
          return {
            title: "Win already recorded",
            type: "warning",
          };
        }
        return {};
      },
      success: () => {
        $("#winModal").modal("hide");
        throwConfetti();
        showToast({
          title:
            'Win recorded! <a target="_blank" href="https://www.g2.com/products/sourcewhale/take_survey">Leave a review</a>',
          type: "success",
        });
        $("placementType").val("");
        $("#winContact").attr("data-candidate-id", "").val("");
        $("#placementValue").val("");
        $("#placementNotes").val("");
        $('[data-toggle="tooltip"]').tooltip("dispose");
      },
    });
  });
  $("#winModal select").selectpicker();

  const $winContact = $("#winModal #winContact");
  $('[data-toggle="tooltip"]').tooltip();
  $winContact.autocomplete({
    source: (request, response) => {
      const { term } = request;
      wrappedGet({
        url: `/api/wins/query?value=${encodeURIComponent(term)}`,
        success: (data) => {
          const { results } = data;
          response(results);
        },
      });
    },
  });

  $winContact.data("ui-autocomplete")._renderItemData = (ul, item) => {
    const { campaignName, name, emails = [], candidateId } = item;
    const email = emails[0] || "";
    const campaignDescription = campaignName
      ? `On campaign '${campaignName}'`
      : "Not on a campaign";
    $(ul).append(
      `
<div id="winCandidate${candidateId}" class="win-candidate-select">
  <img src="/assets/img/icons/user.png" class="rounded-circle photo-image mr-2" style="width: 1.5rem; height: 1.5rem">
  <div>
    <span class="candidate-name">${name}</span>
    <i class="candidate-email">${email}</i>
    <i class="campaign-name">${campaignDescription}</i>
  </div>
</div>`,
    );

    $(`#winCandidate${candidateId}`).on("click", () => {
      $winContact.val(name);
      $winContact.attr("data-candidate-id", candidateId);
      $winContact.autocomplete("close");
    });
  };
  $winContact.on("focus", () => {
    $winContact.autocomplete("search", $winContact.val());
  });
};

const WIN_BUTTON_HTML = `
<!-- Win button -->
<div id="winBtn"><i class="fa-solid fa-trophy" style="color: #fff"></i></div>
`;

/** @param {string} currency */
const initButton = (currency) => {
  $("#winBtn").on("click", () => {
    if ($("#winModal").length === 0) {
      $(document.body).append(winModalHtml(currency));
      initModal();
    }
    $("#winModal").modal("show");
  });
};

export const initializeWins = (init = true) => {
  if (init) {
    // restrict to agency customers only
    const { teamKind, currency, isPlgTrial } = getUser();
    if (teamKind !== "agency" || isPlgTrial) return;

    const $wrapper = $("#wrapper");
    $wrapper.append(WIN_BUTTON_HTML);
    initButton(currency);
  }
};
